import { useState } from 'react';
import PropTypes from 'prop-types';
import { Section, SectionContainer } from '@components/Section';
import Priorities from '@components/Priorities/Priorities';
import CustomPriorities from '@components/Priorities/CustomPriorities';
import TextInput from '@hiredigital/ui/Input/SimpleTextInput';

const PrioritiesSection = ({
  title = 'Priorities',
  subtitle = 'Learn how Hire Digital can help your team. Explore some of our priorities by sector, function, or skill for your business.',
  hasSearch = true,
  searchLabel = 'Search Priorities',
  searchPlaceholder = 'Explore different types of Hire Digital talents by sector or organization type.',
  light = true,
  data,
}) => {
  const [searchTerm, setSearchTerm] = useState(undefined);

  const Elem = data?.length ? CustomPriorities : Priorities;

  return (
    <SectionContainer style={{ margin: 'auto' }} type={light ? '' : SectionContainer.Type.DARKBLUE}>
      <Section
        title={title}
        subtitle={subtitle}
        textColor={Section.Type.NORMAL}
        textType={light ? Section.Color.BLACK : Section.Color.WHITE}>
        {hasSearch && (
          <div style={{ marginBottom: '20px' }}>
            <TextInput
              name={`prioritySearch`}
              label={searchLabel}
              placeholder={searchPlaceholder}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </div>
        )}
        <Elem light={light} searchTerm={searchTerm} data={data} />
      </Section>
    </SectionContainer>
  );
};

PrioritiesSection.propTypes = {
  title: PropTypes.string,
  light: PropTypes.bool,
  subtitle: PropTypes.string,
};

export default PrioritiesSection;
